// Track the `LAYOUT_BUILDER_JS_FINISHED_EXECUTING` lifecycle (after the JS has been downloaded and parsed
// and is just starting to run). Need to use `Date.now` instead of `performance.now` because the
// iframe's `performance.timing.navigationStart` will not match the parent's `navigationStart`
window.hsQueuedLifecycleTimestamps = window.hsQueuedLifecycleTimestamps || {};
window.hsQueuedLifecycleTimestamps.LAYOUT_BUILDER_JS_FINISHED_EXECUTING =
  Date.now();
if (window.performance.mark) {
  window.performance.mark('LAYOUT_BUILDER_JS_FINISHED_EXECUTING');
}
